import type { TFunction } from 'i18next';

import { formatClockTime } from '../../../../utilities/formatClock';
import { formatNameList } from '../../../../utilities/formatList';
import { channelName } from '../../../passcode-auth';
import { formatWindow, modeLabel, severityLabel } from '../../../close-the-loop';
import type { DeliveryMode, QuietWindow, Severity } from '../../../close-the-loop';
import type { AlertsReach, ModeGroups } from '../../domain/doneSummary';

export const alertsText = (t: TFunction, alerts: AlertsReach): string => {
  if (alerts.kind === 'appOnly') return t('onboarding.done.appOnly', 'In the app only');
  const channel = channelName(t, alerts.channel);
  if (alerts.masked === null) return channel;
  return t('onboarding.done.channelTo', '{{channel}} · {{number}}', {
    channel,
    number: alerts.masked,
  });
};

const GROUP_ORDER: readonly (readonly [keyof ModeGroups, DeliveryMode])[] = [
  ['now', 'NOW'],
  ['digest', 'DIGEST'],
  ['off', 'OFF'],
];

const modeGroupText = (t: TFunction, mode: DeliveryMode, severities: readonly Severity[], locale: string): string => {
  const modeName = modeLabel(t, mode);
  const names = formatNameList(
    severities.map((severity) => severityLabel(t, severity)),
    locale,
  );
  return t('onboarding.done.modeGroup', '{{mode}}: {{severities}}', { mode: modeName, severities: names });
};

export const modeGroupsText = (t: TFunction, modes: ModeGroups, locale: string): string =>
  GROUP_ORDER.filter(([group]) => modes[group].length > 0)
    .map(([group, mode]) => modeGroupText(t, mode, modes[group], locale))
    .join(' · ');

export const morningEmailText = (t: TFunction, arrives: boolean, digestAtMinute: number, locale: string): string =>
  arrives ? formatClockTime(digestAtMinute, locale) : t('onboarding.done.morningEmailUnverified', 'Verify your email to get it');

export const quietHoursText = (t: TFunction, quiet: QuietWindow | null, locale: string): string =>
  quiet ? formatWindow(quiet, locale) : t('onboarding.done.quietOff', 'Off');
